// Branding / organization API endpoints
// Public organization lookup (by domain / id)
export const BRANDING_BY_DOMAIN_ENDPOINT = "api/org/public";
export const BRANDING_BY_ID_ENDPOINT = "api/org/public";

// Admin branding configuration endpoints (may be implemented separately on backend)
export const BRANDING_CONFIG_ENDPOINT = "api/branding";
export const BRANDING_LOGO_ENDPOINT = "api/branding";
export const BRANDING_COLORS_ENDPOINT = "api/branding";
export const BRANDING_TYPOGRAPHY_ENDPOINT = "api/branding";
export const BRANDING_LOGIN_PAGE_ENDPOINT = "api/branding";
export const BRANDING_LOGIN_BACKGROUND_ENDPOINT = "api/branding";
export const BRANDING_EMAIL_ENDPOINT = "api/branding";
export const BRANDING_METADATA_ENDPOINT = "api/branding";
export const BRANDING_DOMAIN_ENDPOINT = "api/branding";
export const BRANDING_DOMAIN_VERIFY_ENDPOINT = "api/branding";
export const BRANDING_DOMAIN_STATUS_ENDPOINT = "api/branding";
